// extracted by mini-css-extract-plugin
export default {"css-hz1bth-MuiDialog-container":"CustomModal_css-hz1bth-MuiDialog-container__tqsRX"};